import { render } from "./CoursePrice.vue?vue&type=template&id=25ae0a9f&scoped=true"
import script from "./CoursePrice.vue?vue&type=script&lang=js"
export * from "./CoursePrice.vue?vue&type=script&lang=js"

import "./CoursePrice.vue?vue&type=style&index=0&id=25ae0a9f&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ae0a9f"]])

export default __exports__